// Stripe configuration
// This file initializes the Stripe instance with your publishable key

import { loadStripe } from '@stripe/stripe-js';
import type { Stripe } from '@stripe/stripe-js';

const rawStripeKey = import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY;
const stripePublishableKey =
  typeof rawStripeKey === 'string' ? rawStripeKey.trim() : '';
const normalizedStripeKey = stripePublishableKey.startsWith('pk_')
  ? stripePublishableKey
  : null;

// Lazily initialized — NOT called until getStripePromise() is first invoked.
//
// Calling loadStripe() at module-parse time causes Stripe.js to inject its
// fixed-position "TEST MODE" badge on every page of the app (even non-payment
// pages such as the message composer), which can overlap UI elements like the
// Send button. By deferring initialization to the first time a payment
// component renders, the badge only appears on pages that actually use Stripe.
let _stripePromise: Promise<Stripe | null> | null = null;

export function getStripePromise(): Promise<Stripe | null> {
  if (_stripePromise === null) {
    _stripePromise = normalizedStripeKey
      ? loadStripe(normalizedStripeKey)
      : Promise.resolve(null);
  }
  return _stripePromise;
}

// Test card numbers for development
export const TEST_CARDS = {
  SUCCESS: '4242424242424242',
  DECLINE: '4000000000000002',
  INSUFFICIENT_FUNDS: '4000000000009995',
  REQUIRE_3DS: '4000002500003155',
};

export const TEST_BANK_ACCOUNT = {
  ACCOUNT_NUMBER: '000123456789',
  ROUTING_NUMBER: '110000000', // Valid test routing number
};
